import React from 'react';
import { t } from 'i18next';
import { Text, Wrapper } from './AgreementLegends.styles';
import DisagreementIcon from '@/assets/icons/disagreement.svg?react';
import HighAgreementIcon from '@/assets/icons/high_agreement.svg?react';
import LowAgreementIcon from '@/assets/icons/low_agreement.svg?react';
import SomeAgreementIcon from '@/assets/icons/some_agreement.svg?react';

export const HighAgreement = () => {
  return (
    <Wrapper>
      <HighAgreementIcon />
      <Text>{t('report.results.highAgreement')}</Text>
    </Wrapper>
  );
};

export const SomeAgreement = () => {
  return (
    <Wrapper>
      <SomeAgreementIcon />
      <Text>{t('report.results.moderateAgreement')}</Text>
    </Wrapper>
  );
};

export const LowAgreement = () => {
  return (
    <Wrapper>
      <LowAgreementIcon />
      <Text>{t('report.results.lowAgreement')}</Text>
    </Wrapper>
  );
};

export const Disagreement = () => {
  return (
    <Wrapper>
      <DisagreementIcon />
      <Text>{t('report.results.disagreement')}</Text>
    </Wrapper>
  );
};
